/* Kudos3D — Shopify theme JS
   Adapted from partials.js: routeSvg() kept intact, mount* replaced by Liquid.
   Route SVG placeholders are rendered into [data-route-seed] elements at DOMContentLoaded. */

(function () {
  /* ── seeded PRNG helpers ─────────────────────────────────── */
  function hash(str) {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = (h * 16777619) >>> 0; }
    return h;
  }
  function mulberry(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* ── smooth bezier path builders (closed contour rings + open route) ── */
  function closedSmooth(pts) {
    const n = pts.length;
    let d = 'M ' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
    for (let i = 0; i < n; i++) {
      const p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
      const c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
      const c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
      d += ' C ' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ', ' + c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ', ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    return d + ' Z';
  }
  function smoothOpen(pts) {
    let d = 'M ' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
    for (let i = 0; i < pts.length - 1; i++) {
      const p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      const c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
      const c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
      d += ' C ' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ', ' + c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ', ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    return d;
  }

  /* ── route SVG generator ────────────────────────────────── */
  function routeSvg(seed, colors) {
    const s = seed || 'demo';
    const id = 'rs' + Math.abs(hash(s));

    if (colors) {
      /* Poster map: single organic coastline — land top, water bottom, route hugs the coast */
      const cAgua = colors.agua || '#34BBCC';
      const cBase = colors.base || '#1B3A6B';
      const cVias = colors.vias || '#F0EDE8';
      const cRuta = colors.ruta || '#FF6B00';
      const W = 600, H = 600;

      /* ── Coastline ── */
      let rng = mulberry(hash(s) + 3);
      const nC   = 54;
      const midY = H * (0.50 + rng() * 0.12);
      const tilt = (rng() - 0.5) * 50;
      const yRaw = Array.from({length: nC}, (_, i) => {
        const t = i / (nC - 1);
        return midY + tilt * (t - 0.5) + (rng() - 0.5) * 75;
      });
      let ySm = yRaw.slice();
      for (let p = 0; p < 5; p++)
        ySm = ySm.map((v, i, a) => {
          const l2 = a[Math.max(0, i-2)], l1 = a[Math.max(0, i-1)];
          const r1 = a[Math.min(nC-1, i+1)], r2 = a[Math.min(nC-1, i+2)];
          return (l2 + l1*2 + v*4 + r1*2 + r2) / 10;
        });
      const xAt = (i) => i / (nC - 1) * W;
      const landPts = Array.from({length: nC}, (_, i) =>
        `${xAt(i).toFixed(1)},${ySm[i].toFixed(1)}`
      ).join(' ') + ` ${W},0 0,0`;
      const gid = `${id}g`;

      /* ── Topographic contour lines (parallel to coast, stacked above it) ── */
      let rC = mulberry(hash(s) + 7);
      let contours = '';
      for (let k = 1; k <= 8; k++) {
        const offset = k * 28 + rC() * 8;
        const pts = Array.from({length: nC}, (_, i) => {
          const jy = (rC() - 0.5) * 12;
          return `${xAt(i).toFixed(1)},${(ySm[i] - offset + jy).toFixed(1)}`;
        }).join(' ');
        const op = Math.max(0.03, 0.18 - k * 0.02);
        contours += `<polyline points="${pts}" fill="none" stroke="${cVias}" stroke-width="${k <= 2 ? 1.0 : 0.6}" stroke-opacity="${op}"/>`;
      }

      /* ── Streets: rotated grid clipped to land, irregular spacing ── */
      let rS = mulberry(hash(s) + 17);
      const ang = (rS() - 0.5) * 0.18;
      const cA = Math.cos(ang), sA = Math.sin(ang);
      const rot = (px, py) => [
        300 + (px-300)*cA - (py-300)*sA,
        300 + (px-300)*sA + (py-300)*cA
      ];
      let streets = '';
      /* Vertical streets (perpendicular to coast) */
      const nV = 22 + Math.floor(rS() * 8);
      const vWts = Array.from({length: nV}, () => 0.4 + rS() * 1.2);
      const vSum = vWts.reduce((a, b) => a + b, 0);
      let vAcc = 0;
      for (let j = 0; j < nV; j++) {
        vAcc += vWts[j];
        const px = vAcc / vSum * W;
        const isMain = j % 5 === 0;
        const [x1,y1] = rot(px, 0); const [x2,y2] = rot(px, H);
        streets += `<line x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke-width="${isMain?1.4:0.5}" stroke-opacity="${isMain?0.6:0.28}"/>`;
      }
      /* Horizontal streets (parallel to coast) */
      const nH = 10 + Math.floor(rS() * 5);
      const hWts = Array.from({length: nH}, () => 0.4 + rS() * 1.2);
      const hSum = hWts.reduce((a, b) => a + b, 0);
      let hAcc = 0;
      for (let i = 0; i < nH; i++) {
        hAcc += hWts[i];
        const py = (hAcc / hSum) * midY * 0.90;
        const isMain = i % 3 === 0;
        const [x1,y1] = rot(0, py); const [x2,y2] = rot(W, py);
        streets += `<line x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke-width="${isMain?1.4:0.5}" stroke-opacity="${isMain?0.6:0.28}"/>`;
      }

      /* ── Route: follows the coastline, 12-28px above it (always on land) ── */
      let rR = mulberry(hash(s) + 55);
      const rStart = Math.floor((0.06 + rR() * 0.10) * nC);
      const rEnd   = Math.floor((0.82 + rR() * 0.10) * nC);
      const rpts   = [];
      for (let i = rStart; i <= rEnd; i++) {
        const up = 12 + rR() * 16;
        const jx = (rR() - 0.5) * 8;
        const jy = (rR() - 0.5) * 8;
        rpts.push(`${(xAt(i) + jx).toFixed(0)} ${(ySm[i] - up + jy).toFixed(0)}`);
      }
      const rpath = 'M ' + rpts.join(' L ');

      return `<svg viewBox="0 0 ${W} ${H}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style="width:100%;height:100%">
        <defs>
          <linearGradient id="${gid}" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%"   stop-color="#ffffff" stop-opacity="0.14"/>
            <stop offset="55%"  stop-color="#ffffff" stop-opacity="0.03"/>
            <stop offset="100%" stop-color="#000000" stop-opacity="0.18"/>
          </linearGradient>
          <clipPath id="${id}-c"><polygon points="${landPts}"/></clipPath>
        </defs>
        <rect width="${W}" height="${H}" fill="${cAgua}"/>
        <polygon points="${landPts}" fill="${cBase}"/>
        <polygon points="${landPts}" fill="url(#${gid})"/>
        <g clip-path="url(#${id}-c)" stroke="${cVias}" fill="none">${contours}${streets}</g>
        <path d="${rpath}" stroke="rgba(0,0,0,0.28)" stroke-width="10" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="${rpath}" stroke="${cRuta}" stroke-width="4.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="${rpts[0].split(' ')[0]}" cy="${rpts[0].split(' ')[1]}" r="5" fill="${cVias}" stroke="${cBase}" stroke-width="1.5"/>
        <circle cx="${rpts[rpts.length-1].split(' ')[0]}" cy="${rpts[rpts.length-1].split(' ')[1]}" r="7" fill="${cRuta}" stroke="${cVias}" stroke-width="2"/>
      </svg>`;
    }

    /* Default dark mode: used in hero, catalog cards and homepage —
       smoothed concentric contour rings around a focal point, plus a
       glowing hand-drawn route line with hollow-start / solid-end dots. */
    const fid = id + 'g';
    let rc = mulberry(hash(s) + 7);
    const fx = 220 + rc() * 160, fy = 220 + rc() * 160;
    const maxR = 260, bands = 7;
    let contours = '';
    for (let b = 0; b < bands; b++) {
      const r = maxR * (1 - b / bands) * (0.95 + rc() * 0.1);
      const ncv = 24;
      const ph1 = rc() * 6.28, ph2 = rc() * 6.28, ph3 = rc() * 6.28;
      const a1 = 0.5 + rc() * 0.8, a2 = 0.3 + rc() * 0.5, a3 = rc() * 0.4;
      const pts = [];
      for (let i = 0; i < ncv; i++) {
        const t = (i / ncv) * 6.2832;
        const rr = r * (1 + a1 * 0.16 * Math.sin(t * 2 + ph1) + a2 * 0.11 * Math.sin(t * 3 + ph2) + a3 * 0.07 * Math.sin(t * 5 + ph3));
        pts.push([fx + Math.cos(t) * rr, fy + Math.sin(t) * rr * 0.78]);
      }
      const op = (0.1 + 0.35 * (b / bands)).toFixed(2);
      const col = b >= bands - 2 ? '#a3805f' : '#4a3626';
      contours += `<path d="${closedSmooth(pts)}" fill="none" stroke="${col}" stroke-width="1" opacity="${op}"/>`;
    }

    let rr2 = mulberry(hash(s) + 55);
    const steps = 6, rsx = 90, rex = 520;
    let rpy = 380 + (rr2() - 0.5) * 120;
    const rpts = [];
    for (let i = 0; i <= steps; i++) {
      const rx2 = rsx + ((rex - rsx) * i) / steps;
      rpy += (rr2() - 0.5) * 90;
      rpy = Math.max(110, Math.min(490, rpy));
      rpts.push([rx2, rpy]);
    }
    const rd = smoothOpen(rpts);

    return `<svg viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style="width:100%;height:100%">
      <defs>
        <radialGradient id="${id}bg" cx="40%" cy="35%" r="85%"><stop offset="0" stop-color="#3a2a22"/><stop offset="0.5" stop-color="#221511"/><stop offset="1" stop-color="#0f0907"/></radialGradient>
        <filter id="${fid}" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="2.4" result="b"/>
          <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>
      <rect width="600" height="600" fill="url(#${id}bg)"/>
      <g>${contours}</g>
      <path class="route-line" d="${rd}" stroke="#ff6b00" stroke-width="5" fill="none" stroke-linecap="round" stroke-linejoin="round" filter="url(#${fid})"/>
      <circle cx="${rpts[0][0].toFixed(1)}" cy="${rpts[0][1].toFixed(1)}" r="6.5" fill="#221511" stroke="#ff6b00" stroke-width="2"/>
      <circle cx="${rpts[rpts.length-1][0].toFixed(1)}" cy="${rpts[rpts.length-1][1].toFixed(1)}" r="8" fill="#ff6b00"/>
    </svg>`;
  }

  /* ── DOM init: populate all [data-route-seed] elements ───── */
  function initRoutes() {
    document.querySelectorAll('[data-route-seed]').forEach(function (el) {
      const seed = el.getAttribute('data-route-seed');
      el.innerHTML = routeSvg(seed);
    });
  }

  /* ── Hero: animated count-up for DIST / ELEV / GAIN stats ──
     Values are merchant-editable free text (e.g. "22.4 km", "3,677 m", "+1,940 m"),
     so we parse out the numeric run and animate it while keeping sign/unit intact. */
  function animateStatValue(el) {
    const raw = el.textContent.trim();
    const m = raw.match(/^([+-]?)([\d.,]+)(.*)$/);
    if (!m) return;
    const sign = m[1], numToken = m[2], suffix = m[3];
    let target, decimals = 0, thousands = false;
    if (numToken.indexOf('.') !== -1) {
      target = parseFloat(numToken.replace(/,/g, ''));
      decimals = (numToken.split('.')[1] || '').length;
    } else if (numToken.indexOf(',') !== -1) {
      const parts = numToken.split(',');
      if (parts[parts.length - 1].length === 3) {
        target = parseInt(numToken.replace(/,/g, ''), 10);
        thousands = true;
      } else {
        target = parseFloat(numToken.replace(',', '.'));
        decimals = parts[parts.length - 1].length;
      }
    } else {
      target = parseFloat(numToken);
    }
    if (!isFinite(target)) return;

    const duration = 1100;
    const start = performance.now();
    function format(v) {
      if (decimals > 0) return v.toFixed(decimals);
      if (thousands) return Math.round(v).toLocaleString('en-US');
      return String(Math.round(v));
    }
    function step(now) {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = sign + format(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  function initHeroStats() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.hero .stat-count').forEach(animateStatValue);
  }

  /* ── Hero: elevation profile mini-chart ─────────────────── */
  function makeElev(seed, w, h) {
    const rand = mulberry(hash(seed || 'demo') + 99);
    const n = 44, pts = [];
    let v = 0.35;
    for (let i = 0; i <= n; i++) {
      v += (rand() - 0.46) * 0.14;
      v = Math.max(0.1, Math.min(0.92, v));
      const hump = Math.sin((i / n) * Math.PI) * 0.32;
      const yv = Math.min(0.98, v * 0.62 + hump);
      pts.push([(w * i) / n, h - yv * h * 0.84 - h * 0.05]);
    }
    const line = 'M ' + pts.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' L ');
    const area = line + ' L ' + w + ' ' + h + ' L 0 ' + h + ' Z';
    const gid = 'ef' + Math.abs(hash(seed || 'demo'));
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#FF6B00" stop-opacity="0.55"/>' +
      '<stop offset="1" stop-color="#FF6B00" stop-opacity="0"/></linearGradient></defs>' +
      '<path d="' + area + '" fill="url(#' + gid + ')"/>' +
      '<path d="' + line + '" fill="none" stroke="#FF6B00" stroke-width="1.6" vector-effect="non-scaling-stroke"/>' +
      '</svg>';
  }
  function initHeroElev() {
    document.querySelectorAll('[data-elev-seed]').forEach(function (el) {
      const seed = el.getAttribute('data-elev-seed');
      el.innerHTML = makeElev(seed, 300, 46);
    });
  }

  /* ── Hero: draw-in animation for the route line ─────────── */
  function initHeroRouteDraw() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const wrap = document.querySelector('.hero .relief [data-route-seed]');
    if (!wrap) return;
    const path = wrap.querySelector('path.route-line');
    if (!path || typeof path.getTotalLength !== 'function') return;
    const len = path.getTotalLength();
    path.style.strokeDasharray = len;
    path.style.strokeDashoffset = len;
    path.getBoundingClientRect(); /* force reflow so the transition applies */
    path.style.transition = 'stroke-dashoffset 1.6s cubic-bezier(.4,0,.1,1) .2s';
    requestAnimationFrame(function () { path.style.strokeDashoffset = '0'; });
  }

  /* ── Catalog filter highlight (visual only) ──────────────── */
  function initFilters() {
    document.querySelectorAll('.filter-group li').forEach(function (li) {
      li.addEventListener('click', function () {
        const siblings = li.parentElement.querySelectorAll('li');
        siblings.forEach(function (s) { s.classList.remove('is-active'); });
        li.classList.add('is-active');
      });
    });
  }

  /* ── Product page: SKU switcher + add-ons + upload ───────── */
  function initProductPage() {
    const frame = document.getElementById('poster-frame');
    if (!frame) return;

    const medalCol = frame.querySelector('.pa-medal-col');
    var variants = window.k3dVariants || [];
    var selectedOption1 = null;
    var selectedOption2 = null;
    var selectedGpxFile = null;
    var multicolorSurcharge = 0;
    var multicolorVariantId = null;
    var filamentLayerColors = {};
    var posterBgColor    = '#FFFFFF';
    var posterTitleColor = '#1A1008';
    var posterNameColor  = '#1A1008';
    var posterStatsColor = '#1A1008';

    function frameColorFor(option2) {
      var v = (option2 || '').toLowerCase();
      if (v.indexOf('oscura') >= 0 || v.indexOf('negro') >= 0 || v.indexOf('poliuretano') >= 0) return '#1a1210';
      if (v.indexOf('blanca') >= 0 || v.indexOf('blanco') >= 0) return '#f0ece4';
      if (v.indexOf('tabaco') >= 0) return '#7a3020';
      if (v.indexOf('cafe') >= 0 || v.indexOf('café') >= 0 || v.indexOf('roble') >= 0 || v.indexOf('madera') >= 0) return '#7a5538';
      return '#c8b89a';
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.option1 === selectedOption1 && v.option2 === selectedOption2;
      }) || null;
    }

    function recompute() {
      var variant = findVariant();
      var total = variant ? (variant.price / 100) : 0;
      var activeAddons = [];
      document.querySelectorAll('.toggle.is-on').forEach(function (t) {
        total += Number(t.dataset.price || 0);
        activeAddons.push(t.dataset.addon);
      });
      total += multicolorSurcharge;
      var priceEl = document.getElementById('price');
      var labelEl = document.getElementById('price-label');
      if (priceEl) priceEl.textContent = variant ? '$' + total.toLocaleString('es-CO') : '—';
      if (labelEl) labelEl.textContent = activeAddons.length > 0 ? 'precio con add-ons' : 'precio base · sin add-ons';
      var propAddons = document.getElementById('prop-addons');
      if (propAddons) propAddons.value = activeAddons.join(', ');
      /* Update variant ID input */
      var variantInput = document.querySelector('#kudos-product-form input[name="id"]');
      if (variant && variantInput) variantInput.value = variant.id;
      /* Update price shown inside each SKU card (fallback to any matching option1 if option2 not yet set) */
      document.querySelectorAll('.sku-card').forEach(function (c) {
        var match = variants.find(function (v) {
          return v.option1 === c.dataset.option1 && v.option2 === selectedOption2;
        });
        if (!match) match = variants.find(function (v) { return v.option1 === c.dataset.option1; });
        var span = c.querySelector('.sku-price');
        if (span) span.textContent = match ? '$' + (match.price / 100).toLocaleString('es-CO') : '—';
      });
      /* Update submit button with running total */
      var submitBtn = document.querySelector('#kudos-product-form [type="submit"]:not([disabled])');
      if (submitBtn && variant) {
        submitBtn.innerHTML = 'Añadir al carrito ($' + total.toLocaleString('es-CO') + ') <span class="arrow">→</span>';
      }
      /* Mirror price + availability into the mobile sticky buy dock */
      var dockPriceEl = document.getElementById('dock-price');
      var dockBtn = document.getElementById('dock-buy-btn');
      if (dockPriceEl) dockPriceEl.textContent = variant ? '$' + total.toLocaleString('es-CO') : '—';
      if (dockBtn) dockBtn.disabled = !variant;
    }

    function setFormat(option1, formatType) {
      selectedOption1 = option1;
      frame.dataset.format = formatType;
      if (medalCol) medalCol.style.display = (formatType === 'horizontal') ? 'flex' : 'none';
      document.querySelectorAll('.sku-card').forEach(function (c) {
        c.classList.toggle('is-on', c.dataset.option1 === option1);
      });
      var specSize = document.getElementById('spec-size');
      if (specSize) specSize.innerHTML = '<b>Tamaño carta</b>';
      var propFormat = document.getElementById('prop-format');
      if (propFormat) propFormat.value = option1;
      recompute();
    }

    document.querySelectorAll('.sku-card').forEach(function (c) {
      c.addEventListener('click', function () { setFormat(c.dataset.option1, c.dataset.format); });
    });

    const upload = document.getElementById('upload');
    const fileInput = document.getElementById('file-input');
    if (upload && fileInput) {
      upload.addEventListener('click', function () { fileInput.click(); });
      fileInput.addEventListener('change', function (e) {
        const f = e.target.files[0];
        if (!f) return;
        const ext = f.name.split('.').pop().toLowerCase();
        const glyph = document.getElementById('upload-glyph');
        const title = document.getElementById('upload-title');
        const sub = document.getElementById('upload-sub');
        if (ext !== 'gpx') {
          selectedGpxFile = null;
          upload.classList.remove('has-file');
          upload.classList.add('has-error');
          if (glyph) glyph.textContent = '✕';
          if (title) title.textContent = 'Solo se aceptan archivos .GPX';
          if (sub) sub.textContent = 'Intentá de nuevo';
          fileInput.value = '';
          return;
        }
        if (f.size > 10 * 1024 * 1024) {
          selectedGpxFile = null;
          upload.classList.remove('has-file');
          upload.classList.add('has-error');
          if (glyph) glyph.textContent = '✕';
          if (title) title.textContent = 'El archivo supera los 10 MB';
          if (sub) sub.textContent = (f.size / 1024 / 1024).toFixed(1) + ' MB · máximo 10 MB';
          fileInput.value = '';
          return;
        }
        upload.classList.remove('has-error');
        selectedGpxFile = f;
        upload.classList.add('has-file');
        if (glyph) glyph.textContent = '✓';
        if (title) title.textContent = f.name;
        if (sub) sub.textContent = (f.size / 1024).toFixed(0) + ' KB · ARCHIVO LISTO';
      });
    }

    document.querySelectorAll('.toggle').forEach(function (t) {
      t.addEventListener('click', function () {
        t.classList.toggle('is-on');
        var engravingField = document.getElementById('engraving-field');
        var grabadoToggle = document.getElementById('toggle-grabado');
        if (engravingField && grabadoToggle) {
          engravingField.classList.toggle('is-visible', grabadoToggle.classList.contains('is-on'));
        }
        recompute();
      });
    });

    document.querySelectorAll('.frame-swatch').forEach(function (s) {
      s.addEventListener('click', function () {
        document.querySelectorAll('.frame-swatch').forEach(function (x) { x.classList.remove('is-on'); });
        s.classList.add('is-on');
        selectedOption2 = s.dataset.option2;
        frame.style.backgroundColor = frameColorFor(selectedOption2);
        var propFrame = document.getElementById('prop-frame');
        if (propFrame) propFrame.value = s.dataset.option2;
        recompute();
      });
    });

    /* Initialize selections from first rendered card/swatch */
    var firstCard = document.querySelector('.sku-card');
    var firstSwatch = document.querySelector('.frame-swatch');
    if (firstCard) { selectedOption1 = firstCard.dataset.option1; frame.dataset.format = firstCard.dataset.format || 'vertical'; }
    if (firstSwatch) { selectedOption2 = firstSwatch.dataset.option2; frame.style.backgroundColor = frameColorFor(selectedOption2); }
    recompute();

    /* Cart API: intercept submit to bundle main product + selected add-ons */
    var productForm = document.getElementById('kudos-product-form');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var submitBtn = productForm.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Añadiendo…'; }

        /* Collect line item properties from all named inputs inside the form */
        var properties = {};
        productForm.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(function (el) {
          if (el.value.trim()) {
            var key = el.name.slice('properties['.length, -1);
            properties[key] = el.value.trim();
          }
        });

        /* Bundle id: ties this map to its add-ons so el carrito los agrupa bajo el
           mismo mapa (cada mapa con sus propios add-ons) en vez de mostrarlos sueltos. */
        var bundleId = 'set_' + Date.now() + '_' + Math.random().toString(36).substring(2, 8);
        properties['_bundle'] = bundleId;

        /* Main product item */
        var mainId = parseInt(productForm.querySelector('input[name="id"]').value, 10);
        var items = [{ id: mainId, quantity: 1, properties: properties }];

        /* Add selected add-on items, marcados como add-on y atados a este bundle */
        productForm.querySelectorAll('.toggle.is-on').forEach(function (t) {
          var vid = parseInt(t.dataset.variant, 10);
          if (vid) items.push({ id: vid, quantity: 1, properties: { _bundle: bundleId, _addon: t.dataset.addon || 'Add-on' } });
        });

        /* Add multi-color surcharge if active */
        if (multicolorSurcharge > 0) {
          if (multicolorVariantId) {
            items.push({ id: multicolorVariantId, quantity: 1, properties: { _bundle: bundleId, _addon: 'Impresión multicolor' } });
          } else {
            properties['_multicolor_surcharge'] = '10000';
          }
        }

        var N8N_WEBHOOK = 'https://n8n-n8n.nq0fhj.easypanel.host/webhook/subir-gpx';

        function addToCart() {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); });
              return res.json();
            })
            .then(function () { window.location.href = '/cart'; })
            .catch(function (err) {
              if (submitBtn) { submitBtn.disabled = false; recompute(); }
              alert('No se pudo añadir al carrito: ' + err.message);
            });
        }

        if (selectedGpxFile) {
          if (submitBtn) submitBtn.textContent = 'Subiendo archivo…';
          /* El gpx_id se genera acá (lado Shopify) para que la orden sea la fuente de
             verdad: queda guardado en la line item property aunque N8N falle, y N8N solo
             guarda el archivo en Drive bajo este mismo id. */
          var gpxId = 'gpx_' + Date.now() + '_' + Math.random().toString(36).substring(2, 10);
          properties['_gpx_id'] = gpxId;
          var fd = new FormData();
          fd.append('file', selectedGpxFile);
          fd.append('gpx_id', gpxId);
          fd.append('productId', productForm.querySelector('input[name="id"]').value);
          Object.keys(properties).forEach(function(key) { fd.append(key, properties[key]); });
          if (Object.keys(filamentLayerColors).length) {
            fd.append('filament_colors_json', JSON.stringify(filamentLayerColors));
          }
          fetch(N8N_WEBHOOK, { method: 'POST', body: fd })
            .then(function (res) { return res.ok ? res.json() : Promise.reject('Error al subir el archivo'); })
            .catch(function (err) {
              console.warn('GPX upload failed (proceeding to cart anyway):', err);
            })
            .finally(function () {
              if (submitBtn) submitBtn.textContent = 'Añadiendo…';
              addToCart();
            });
        } else {
          addToCart();
        }
      });
    }

    /* ── Poster color pickers ──────────────────────────────── */
    function hexRgba(hex, a) {
      var r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
      return 'rgba('+r+','+g+','+b+','+a+')';
    }

    function applyPosterColors() {
      var art = document.querySelector('.poster-art');
      if (!art) return;
      art.style.background = posterBgColor;
      art.querySelectorAll('.pa-title h2').forEach(function(el) { el.style.color = posterTitleColor; });
      art.querySelectorAll('.pa-name').forEach(function(el) { el.style.color = posterNameColor; });
      art.querySelectorAll('.pa-stats .val').forEach(function(el) { el.style.color = posterStatsColor; });
      art.querySelectorAll('.pa-stats .lbl').forEach(function(el) { el.style.color = hexRgba(posterStatsColor, 0.45); });
      art.querySelectorAll('.stat-icon').forEach(function(el) { el.style.color = hexRgba(posterStatsColor, 0.35); });
      var statsEl = art.querySelector('.pa-stats');
      if (statsEl) statsEl.style.borderTopColor = hexRgba(posterStatsColor, 0.12);
      var mapEl = art.querySelector('.pa-map');
      if (mapEl) mapEl.style.borderColor = hexRgba(posterStatsColor, 0.12);
      var medalCol = art.querySelector('.pa-medal-col');
      if (medalCol) medalCol.style.borderRightColor = hexRgba(posterStatsColor, 0.1);
      var propBg = document.getElementById('prop-poster-bg');
      var propTitle = document.getElementById('prop-poster-title');
      var propName = document.getElementById('prop-poster-name');
      var propStats = document.getElementById('prop-poster-stats');
      if (propBg)    propBg.value    = posterBgColor;
      if (propTitle) propTitle.value = posterTitleColor;
      if (propName)  propName.value  = posterNameColor;
      if (propStats) propStats.value = posterStatsColor;
      var conflict = [posterTitleColor, posterNameColor, posterStatsColor].some(function(c) {
        return c.toLowerCase() === posterBgColor.toLowerCase();
      });
      var warn = document.getElementById('poster-color-warning');
      if (warn) warn.classList.toggle('is-visible', conflict);
      var btn = document.getElementById('kudos-submit-btn');
      if (btn) {
        if (conflict) {
          btn.disabled = true;
          btn.innerHTML = '⚠&nbsp; Un color de texto coincide con el fondo';
        } else if (!btn.disabled || btn.innerHTML.indexOf('coincide') >= 0 || btn.innerHTML.indexOf('iguales') >= 0) {
          btn.disabled = false;
          recompute();
        }
      }
    }

    function buildPosterSwatches() {
      var colors = window.k3dPosterColors;
      var hasPalette = Array.isArray(colors) && colors.length;

      var types = [
        { key: 'bg',    get: function() { return posterBgColor; },    set: function(v) { posterBgColor = v; } },
        { key: 'title', get: function() { return posterTitleColor; }, set: function(v) { posterTitleColor = v; } },
        { key: 'name',  get: function() { return posterNameColor; },  set: function(v) { posterNameColor = v; } },
        { key: 'stats', get: function() { return posterStatsColor; }, set: function(v) { posterStatsColor = v; } },
      ];

      types.forEach(function(type) {
        var wrap = document.getElementById('poster-' + type.key + '-swatches');
        if (!wrap) return;
        var initial = type.get();

        if (hasPalette) {
          colors.forEach(function(col) {
            var sw = document.createElement('button');
            sw.type = 'button';
            sw.className = 'poster-swatch';
            sw.title = col.name;
            sw.style.background = col.hex;
            if (col.hex.toLowerCase() === initial.toLowerCase()) sw.classList.add('is-selected');
            sw.addEventListener('click', function() {
              wrap.querySelectorAll('.poster-swatch').forEach(function(s) { s.classList.remove('is-selected'); });
              sw.classList.add('is-selected');
              var customBtn = wrap.querySelector('.poster-custom-btn');
              if (customBtn) {
                customBtn.classList.remove('is-active');
                customBtn.style.background = '';
                var span = customBtn.querySelector('span');
                if (span) span.style.display = '';
                var inp = customBtn.querySelector('input[type="color"]');
                if (inp) inp.value = col.hex;
              }
              type.set(col.hex);
              applyPosterColors();
            });
            wrap.appendChild(sw);
          });
        }

        var customLabel = document.createElement('label');
        customLabel.className = 'poster-custom-btn';
        customLabel.title = 'Color personalizado';
        var customSpan = document.createElement('span');
        customSpan.textContent = '+';
        var colorInput = document.createElement('input');
        colorInput.type = 'color';
        colorInput.value = initial;
        customLabel.appendChild(customSpan);
        customLabel.appendChild(colorInput);
        wrap.appendChild(customLabel);

        colorInput.addEventListener('input', function() {
          wrap.querySelectorAll('.poster-swatch').forEach(function(s) { s.classList.remove('is-selected'); });
          customLabel.classList.add('is-active');
          customLabel.style.background = colorInput.value;
          customSpan.style.display = 'none';
          type.set(colorInput.value);
          applyPosterColors();
        });
      });

      applyPosterColors();
      updatePosterMap();
    }

    function updatePosterMap() {
      var mapEl = document.querySelector('.pa-map[data-route-seed]');
      if (!mapEl) return;
      mapEl.innerHTML = routeSvg(mapEl.getAttribute('data-route-seed'), {
        base: filamentLayerColors['Base'] || '#1B3A6B',
        agua: filamentLayerColors['Agua'] || '#34BBCC',
        vias: filamentLayerColors['Vías'] || '#F0EDE8',
        ruta: filamentLayerColors['Ruta'] || '#FF6B00',
      });
    }

    /* Multi-color surcharge: listen to 3D viewer color changes */
    var visor = document.getElementById('visor-3d');
    if (visor) {
      var surchargePrice = parseInt(visor.dataset.surchargePrice || '0', 10);
      var surchargeVariantRaw = visor.dataset.surchargeVariant;
      if (surchargeVariantRaw) multicolorVariantId = parseInt(surchargeVariantRaw, 10);
      document.addEventListener('kudos3d:colorchange', function (e) {
        var isMulti = e.detail.uniqueColors > 3;
        multicolorSurcharge = isMulti ? surchargePrice : 0;
        if (e.detail.layerColors) {
          filamentLayerColors = e.detail.layerColors;
          var propFilament = document.getElementById('prop-filament-colors');
          if (propFilament) {
            propFilament.value = Object.keys(filamentLayerColors).map(function(k) {
              return k + ': ' + filamentLayerColors[k];
            }).join(' · ');
          }
          updatePosterMap();
        }
        var notice = document.getElementById('multicolor-notice');
        if (notice) notice.style.display = isMulti ? 'flex' : 'none';
        recompute();
      });
    }

    /* Live preview: update poster art from route data fields */
    function bindPreviewField(fieldId, targetId, transform) {
      var el = document.getElementById(fieldId);
      var target = document.getElementById(targetId);
      if (!el || !target) return;
      el.addEventListener('input', function () {
        target.textContent = transform ? transform(el.value) : (el.value || target.dataset.default);
      });
      target.dataset.default = target.textContent;
    }
    bindPreviewField('field-ruta', 'art-title', function (v) { return v ? v.toUpperCase() : document.getElementById('art-title').dataset.default; });
    bindPreviewField('field-atleta', 'art-atleta', function (v) { return v ? v.toUpperCase() : document.getElementById('art-atleta').dataset.default; });
    bindPreviewField('field-dist', 'stat-dist', null);
    bindPreviewField('field-tiempo', 'stat-tiempo', null);
    bindPreviewField('field-elev', 'stat-elev', null);
    bindPreviewField('field-ritmo', 'stat-ritmo', null);

    /* País: dropdown con banderas reales (SVG de flagcdn.com) + buscador. Guarda el
       nombre del país en el campo oculto y lo refleja en el póster (art-loc). */
    (function () {
      var root = document.getElementById('pais-select');
      if (!root) return;
      var hidden  = document.getElementById('field-pais');
      var trigger = root.querySelector('.flag-select__trigger');
      var current = root.querySelector('.flag-select__current');
      var search  = root.querySelector('.flag-select__search-input');
      var optionsUl = root.querySelector('.flag-select__options');
      var artLoc  = document.getElementById('art-loc');
      if (artLoc && !artLoc.dataset.default) artLoc.dataset.default = artLoc.textContent;

      var COUNTRIES = [
        { n: 'Colombia', c: 'co' }, { n: 'Alemania', c: 'de' }, { n: 'Argentina', c: 'ar' },
        { n: 'Bolivia', c: 'bo' }, { n: 'Brasil', c: 'br' }, { n: 'Canadá', c: 'ca' },
        { n: 'Chile', c: 'cl' }, { n: 'Costa Rica', c: 'cr' }, { n: 'Cuba', c: 'cu' },
        { n: 'Ecuador', c: 'ec' }, { n: 'El Salvador', c: 'sv' }, { n: 'España', c: 'es' },
        { n: 'Estados Unidos', c: 'us' }, { n: 'Francia', c: 'fr' }, { n: 'Guatemala', c: 'gt' },
        { n: 'Honduras', c: 'hn' }, { n: 'Italia', c: 'it' }, { n: 'México', c: 'mx' },
        { n: 'Nicaragua', c: 'ni' }, { n: 'Panamá', c: 'pa' }, { n: 'Paraguay', c: 'py' },
        { n: 'Perú', c: 'pe' }, { n: 'Portugal', c: 'pt' }, { n: 'Puerto Rico', c: 'pr' },
        { n: 'Reino Unido', c: 'gb' }, { n: 'República Dominicana', c: 'do' }, { n: 'Uruguay', c: 'uy' },
        { n: 'Venezuela', c: 've' }
      ];
      function flagUrl(c) { return 'https://flagcdn.com/' + c + '.svg'; }

      function selectCountry(co) {
        hidden.value = co.n;
        current.innerHTML = '<img src="' + flagUrl(co.c) + '" alt=""><span>' + co.n + '</span>';
        optionsUl.querySelectorAll('.flag-select__option').forEach(function (o) {
          o.classList.toggle('is-selected', o.dataset.value === co.n);
        });
        if (artLoc) artLoc.textContent = co.n.toUpperCase();
      }

      COUNTRIES.forEach(function (co) {
        var li = document.createElement('li');
        li.className = 'flag-select__option';
        li.setAttribute('role', 'option');
        li.dataset.value = co.n;
        li.innerHTML = '<img src="' + flagUrl(co.c) + '" alt="" loading="lazy"><span>' + co.n + '</span>';
        li.addEventListener('click', function () { selectCountry(co); close(); });
        optionsUl.appendChild(li);
      });

      function open() {
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (search) { search.value = ''; filter(''); search.focus(); }
      }
      function close() {
        root.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
      function filter(q) {
        q = (q || '').toLowerCase();
        optionsUl.querySelectorAll('.flag-select__option').forEach(function (o) {
          o.style.display = o.dataset.value.toLowerCase().indexOf(q) >= 0 ? '' : 'none';
        });
      }

      trigger.addEventListener('click', function () {
        root.classList.contains('is-open') ? close() : open();
      });
      if (search) search.addEventListener('input', function () { filter(search.value); });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    })();

    /* Fecha: calendario nativo → guarda la fecha formateada ("15 OCT 2025") en el
       campo oculto y la refleja en el póster. */
    (function () {
      var picker = document.getElementById('field-fecha-picker');
      var hidden = document.getElementById('field-fecha');
      var stat   = document.getElementById('stat-fecha');
      if (!picker || !hidden) return;
      if (stat) stat.dataset.default = stat.textContent;
      var MESES = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
      function format(iso) {
        var p = (iso || '').split('-');
        if (p.length !== 3) return '';
        var y = p[0], m = parseInt(p[1], 10), d = parseInt(p[2], 10);
        if (!y || !m || !d) return '';
        return d + ' ' + MESES[m - 1] + ' ' + y;
      }
      picker.addEventListener('change', function () {
        var formatted = format(picker.value);
        hidden.value = formatted;
        if (stat) stat.textContent = formatted || stat.dataset.default;
      });
    })();

    /* "Otra" activity: show free-text input and swap the property name */
    var activitySelect = document.getElementById('activity');
    var activityWrap   = document.getElementById('activity-custom-wrap');
    var activityCustom = document.getElementById('activity-custom');
    if (activitySelect && activityWrap && activityCustom) {
      activitySelect.addEventListener('change', function () {
        var isOtra = activitySelect.value === 'Otra';
        activityWrap.style.display = isOtra ? 'block' : 'none';
        if (isOtra) {
          activitySelect.removeAttribute('name');
          activityCustom.name = 'properties[Actividad]';
          activityCustom.focus();
        } else {
          activitySelect.name = 'properties[Actividad]';
          activityCustom.removeAttribute('name');
          activityCustom.value = '';
        }
      });
    }

    buildPosterSwatches();
  }

  /* ── Gift card: amount buttons + live preview ────────────── */
  function initGiftCard() {
    const amountEl = document.getElementById('gc-amount');
    if (!amountEl) return;

    document.querySelectorAll('.amount-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.amount-btn').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        const a = b.dataset.amount;
        if (a === 'custom') amountEl.innerHTML = '<span class="currency">$</span>—';
        else amountEl.innerHTML = '<span class="currency">$</span>' + Number(a).toLocaleString('es-CO');
      });
    });

    const recipientInput = document.getElementById('recipient');
    const recipientDisplay = document.getElementById('gc-recipient');
    if (recipientInput && recipientDisplay) {
      recipientInput.addEventListener('input', function (e) {
        recipientDisplay.textContent = (e.target.value || 'EL ATLETA').toUpperCase();
      });
    }
  }

  /* ── Product page: sticky mobile buy dock ───────────────── */
  function initMobileBuyDock() {
    var dock = document.getElementById('mobile-buy-dock');
    var trigger = document.getElementById('kudos-submit-btn');
    if (!dock || !trigger) return;

    var dockBtn = document.getElementById('dock-buy-btn');
    if (dockBtn) {
      dockBtn.addEventListener('click', function () {
        if (!trigger.disabled) trigger.click();
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        dock.classList.toggle('is-visible', visible);
        document.body.classList.toggle('has-buy-dock', visible);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(trigger);
  }

  /* ── Header: hide on scroll-down, show on scroll-up ─────── */
  function initScrollHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      if (y > lastY && y > 80) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = '';
      }
      lastY = y;
    }, { passive: true });
  }

  /* ── Header: mobile menu toggle ─────────────────────────── */
  function initMobileNav() {
    var toggle = document.getElementById('mobile-menu-toggle');
    var nav = document.querySelector('.site-nav');
    if (!toggle || !nav) return;

    function openMenu() {
      nav.classList.add('is-open');
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      nav.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      nav.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && e.target !== toggle && !toggle.contains(e.target)) {
        closeMenu();
      }
    });
  }

  /* ── Boot ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initRoutes();
    initHeroStats();
    initHeroElev();
    initHeroRouteDraw();
    initFilters();
    initProductPage();
    initMobileBuyDock();
    initGiftCard();
    initScrollHeader();
    initMobileNav();
  });

  window.k3d = { routeSvg: routeSvg };
})();
